import { sharedProviderPricingDe, sharedProviderPricingEn, sharedProviderPricingRu } from "../ai/providerPricingTranslations";
import { adminStructureDe, adminStructureEn, adminStructureRu } from "./adminStructureTranslations";

export const sharedAdminDe = {
  ...adminStructureDe,
  ...sharedProviderPricingDe,
  "Admin.Dashboard": "Dashboard",
  "Admin.Tenants": "Mandanten",
  "Admin.Functions": "Mandantenfunktionen",
  "Admin.Interfaces": "Schnittstellen",
  "Admin.AiProviders": "KI-Anbieter",
  "Admin.ProviderCosts": "Anbieterkosten",
  "Admin.AccessEmails": "E-Mail",
  "Admin.ServiceNotifications": "Störungsmeldungen",
  "Admin.ServiceAlertEmailHint": "Adresse, an die eine Meldung geht, sobald eine Fehlerquelle gesperrt wurde. Bleibt das Feld leer, wird trotzdem gesperrt — nur ohne Benachrichtigung.",
  "Admin.ServiceAlertEmailSaveFailed": "Der Empfänger konnte nicht gespeichert werden.",
  "Admin.Models": "Modelle",
  "Admin.Billing": "Tarife",
  "Admin.BillingAndPaymentIntegration": "Tarife & Zahlungen",
  "Admin.BillingAndPaymentIntegrationDescription": "Verwalte Tarife, Creditpreise und die Zahlungsintegration der Plattform.",
  "Admin.BillingAndInvoices": "Tarife & Rechnungen",
  "Admin.BillingAndInvoicesDescription": "Verwalte Tarife, Zahlungsintegration, Rechnungen, Rechnungssteller und Rechnungsdesign in getrennten Bereichen.",
  "Admin.PaymentIntegration": "Zahlungsintegration",
  "Admin.Invoices": "Rechnungen",
  "Admin.PlatformLogs": "Systemprotokoll",
  "Platform logs": "Systemprotokoll",
  "Admin.PlatformManagementDescription": "Gemeinsame Plattformsteuerung für Mandanten, Mandantenfunktionen, Tarife, Schnittstellen und technische Diagnose.",
  "Admin.TenantsDescription": "Verwalte Mandanten, ihre Zugänge und ihre zugeordneten Produktdaten an einer zentralen Stelle.",
  "Admin.NewTenants": "neue Mandanten",
  "Admin.SelectedTenantOrDefaults": "Mandant oder neue Mandanten",
  "Admin.FunctionsDescription": "Funktionen je Mandant und als Vorgabe für neue Mandanten.",
  "Admin.InterfacesDescription": "Verwalte externe Plattform- und Anbieteranbindungen der Anwendung.",
  "Admin.ProviderCostsDescription": "Prüfe die KI-Anbieterkosten nach Zeitraum, Funktion, Anbieter und Modell.",
  "Admin.AccessEmailsDescription": "Versandkonto, Vorlagen, Testversand und Empfänger für Störungsmeldungen.",
  "Admin.BillingDescription": "Verwalte Tarifmodelle, Preisversionen und tarifgebundene Limits der Plattform.",
  "Admin.PaymentIntegrationDescription": "Verwalte die zentrale Zahlungsintegration und den Stripe-Status der Plattform.",
  "Admin.InvoicesDescription": "Systemweite Rechnungen für Buchhaltung, Steuerabgleich und Zahlungsprüfung.",
  "Admin.PlatformLogsDescription": "Technische Ereignisse und API-Aufrufe der Plattform.",
  "Admin.ModelsDescription": "Verwalte zentral, welche Modelle Mandanten und Plattformfunktionen verwenden.",
  "Admin.NewTenantFunctions": "Mandantenfunktionen für neue Mandanten",
  "Admin.TenantFunctions": "Mandantenfunktionen je Mandant",
  "Admin.TenantFunctionAccess": "Mandantenfunktionen",
  "Admin.RegistrationControls": "Registrierungssteuerung",
  "Activate": "aktivieren",
  "Deactivate": "deaktivieren",
  "Activate tenant": "Mandant aktivieren",
  "Deactivate tenant": "Mandant deaktivieren",
  "ToggleTenantActiveConfirm": "Der Status von \"{name}\" wird geändert.",
  "Tenant status saved": "Mandantenstatus gespeichert.",
  "Failed to toggle tenant active status": "Mandantenstatus konnte nicht geändert werden.",
  "AccessDenied": "Zugriff verweigert.",
  "Severity": "Schweregrad",
  "Component": "Komponente",
  "Event type": "Ereignistyp",
  "Message": "Meldung",
  "Context": "Kontext",
  "Technical details": "Technische Details",
  "No technical details": "Keine technischen Details vorhanden.",
  "No platform logs": "Keine Protokolleinträge vorhanden.",
  "Delete all logs": "alle Protokolleinträge löschen",
  "Platform logs deleted": "Protokolleinträge gelöscht.",
  "Method": "Methode",
  "Endpoint": "Endpunkt",
  "Status Code": "Statuscode",
  "Request": "Anfrage",
  "Response": "Antwort",
  "Project": "Projekt",
  "Campaign": "Kampagne",
  "Delete platform logs": "Systemprotokoll leeren",
  "Delete platform logs description": "Alle gespeicherten Protokolleinträge werden dauerhaft gelöscht.",
  "Failed to load platform logs": "Fehler beim Laden der Protokolleinträge.",
  "Failed to delete platform logs": "Fehler beim Löschen der Protokolleinträge.",
  "Functions saved successfully": "Funktionen erfolgreich gespeichert.",
  "Failed to load functions": "Funktionen konnten nicht geladen werden.",
  "Failed to save functions": "Funktionen konnten nicht gespeichert werden.",
  "Offered models saved successfully": "Verfügbare Modelle erfolgreich gespeichert.",
  "Failed to save offered models": "Speichern der verfügbaren Modelle fehlgeschlagen.",
  "Failed to load offered models": "Verfügbare Modelle konnten nicht geladen werden.",
  "Invoices": "Rechnungen",
  "PlatformInvoicesDescription": "Systemweite Rechnungen für Buchhaltung, Steuerabgleich und Zahlungsprüfung.",
  "Invoice number": "Rechnungsnummer",
  "Invoice date": "Rechnungsdatum",
  "Service period": "Leistungszeitraum",
  "Gross amount": "Bruttobetrag",
  "Status": "Status",
  "Receipt": "Beleg",
  "Download": "herunterladen",
  "All tenants": "alle Mandanten",
  "Deleted tenant": "Gelöschter Mandant",
  "Deleted project": "Gelöschtes Projekt",
  "Failed to load invoices": "Rechnungen konnten nicht geladen werden.",
  "Payment integration": "Zahlungsintegration",
  "Provider costs period": "Zeitraum für Anbieterkosten",
  "Last 4 weeks": "letzte 4 Wochen",
  "This month": "dieser Monat",
  "Last 12 months": "letzte 12 Monate",
  "Provider cost breakdown": "Aufstellung der Anbieterkosten",
  "Estimated provider cost": "geschätzte Anbieterkosten",
  "Provider requests": "Provider-Aufrufe",
  "Tokens": "Token",
  "By function": "nach Funktion",
  "By provider": "nach Provider",
  "By model": "nach Modell",
  "Function": "Funktion",
  "Provider": "Provider",
  "Model": "Modell",
  "Operation type": "Operationstyp",
  "Prompt tokens": "Prompt-Token",
  "Completion tokens": "Completion-Token",
  "Total tokens": "Token gesamt",
  "Requests": "Aufrufe",
  "Started": "gestartet",
  "Error message": "Fehlermeldung",
  "completed": "abgeschlossen",
  "failed": "fehlgeschlagen",
  "No provider costs": "Keine Anbieterkosten vorhanden.",
  "Failed to load provider costs": "Anbieterkosten konnten nicht geladen werden.",
  "Provider costs source": "Kostenbasis",
  "Provider costs source description": "Die Aufstellung nutzt erfasste KI-Anbieter-Aufrufe. Die Kosten kommen aus gespeicherten Anbieterpreisen.",
  "ProviderPricingRefreshTriggered": "Providerpreise wurden aktualisiert.",
  "ProviderPricingRefreshStatusPending": "ausstehend",
  "ProviderPricingRefreshStatusRunning": "läuft",
  "ProviderPricingRefreshStatusSuccess": "abgerufen",
  "ProviderPricingRefreshStatusWarning": "eingeschränkt",
  "ProviderPricingRefreshStatusError": "fehlerhaft",
  "ProviderPricingRefreshPendingDescription": "Der tägliche Preisabruf wurde seit dem Start dieses Dienstes noch nicht abgeschlossen.",
  "ProviderPricingRefreshRunningDescription": "Der tägliche Preisabruf läuft gerade.",
  "ProviderPricingRefreshSuccessDescription": "Letzter erfolgreicher Abruf: {time}. Aktualisierte Preise: {count}.",
  "ProviderPricingRefreshWarningDescription": "Der letzte Preisabruf wurde nur teilweise abgeschlossen. Vorhandene verifizierte Preise bleiben als veraltet sichtbar; unbekannte Preise werden nicht geschätzt.",
  "ProviderPricingRefreshForbiddenDescription": "Ein Provider verweigert den Preisabruf mit 403 Forbidden. Vorhandene verifizierte Preise bleiben als veraltet sichtbar; unbekannte Preise werden nicht geschätzt.",
  "ProviderPricingRefreshDetailsPrefix": "Details",
  "ProviderPricingRefreshErrorDescription": "Der letzte Preisabruf ist fehlgeschlagen.",
  "Model provider saved": "Anbieterzugang gespeichert und für Agenten verfügbar.",
  "Model provider added": "Anbieter hinzugefügt.",
  "Model provider removed": "Anbieter entfernt.",
  "Model provider activated": "Anbieter aktiviert.",
  "Model provider deactivated": "Anbieter deaktiviert.",
  "Failed to save model provider secret": "Anbieterzugang konnte nicht gespeichert werden.",
  "Failed to save model providers": "Anbieter konnten nicht gespeichert werden.",
  "Failed to remove model provider": "Anbieter konnte nicht entfernt werden.",
  "Select provider first": "Bitte wähle zuerst einen Anbieter aus.",
  "Api key required": "Bitte gib einen API-Key ein.",
  "Base URL required": "Bitte gib die Basis-URL ein.",
  "Show password": "anzeigen",
  "Hide password": "verbergen",
  "ProviderAccess.Provider": "Anbieter",
  "ProviderAccess.Status": "Status",
  "ProviderAccess.configured": "konfiguriert",
  "ProviderAccess.missing": "fehlt",
  "ProviderAccess.AccessData": "Zugangsdaten",
  "ProviderAccess.OllamaBaseUrlPlaceholder": "http://localhost:11434",
  "ProviderAccess.ApiKeyPlaceholder": "API-Key eingeben",
  "ProviderAccess.ApiKeyUpdatePlaceholder": "API-Key hinterlegt (Eingabe zum Ändern)",
  "ProviderAccess.Actions": "Aktionen",
  "ProviderAccess.UpdateAccess": "aktualisieren",
  "ProviderAccess.SaveAccess": "Zugang speichern",
  "ProviderAccess.TestAccess": "testen",
  "ProviderAccess.Remove": "entfernen",
  "ProviderAccess.Model": "Modell",
  "ProviderAccess.Operation": "Operation",
  "ProviderAccess.Tier": "Stufe",
  "ProviderAccess.InputPerMillion": "Input pro Million",
  "ProviderAccess.CachedInputPerMillion": "gecachter Input pro Million",
  "ProviderAccess.OutputPerMillion": "Output pro Million",
  "ProviderAccess.Source": "Quelle",
  "ProviderAccess.FetchedAt": "Abgerufen am",
  "ProviderAccess.PanelTitle": "Anbieterzugänge",
  "ProviderAccess.ProviderPricingRefreshTitle": "Anbieterpreise",
  "ProviderAccess.ViewProviderPrices": "Anbieterpreise anzeigen",
  "ProviderAccess.ProviderPricingRefreshNow": "jetzt abrufen",
  "ProviderAccess.AddProviderAccess": "Anbieterzugang hinzufügen",
  "ProviderAccess.SelectProvider": "Anbieter auswählen",
  "ProviderAccess.AddProvider": "Anbieter hinzufügen",
  "ProviderAccess.Deactivate": "löschen",
  "ProviderAccess.NoProvidersConfigured": "Keine Anbieter konfiguriert",
  "ProviderAccess.ProviderPriceList": "Anbieterpreisliste",
  "ProviderAccess.Close": "Schließen",
  "ProviderAccess.NoProviderPricesAvailable": "Keine Anbieterpreise verfügbar",
  // platformDashboardKpis (mQmarketing). "Selected period" is provided by sharedPeriodSelector.
  "System": "System",
  "Platform readiness": "Betriebsbereitschaft",
  "Live connection": "Live-Verbindung",
  "Server events": "Serverereignisse",
  "Active agents": "aktive Agenten",
  "Waiting agents": "wartende Agenten",
  "Costs": "Kosten",
  "Quality cases": "Qualitätsfälle",
  "needs attention": "braucht Aufmerksamkeit",
  "PlatformConnectionStatus_waiting": "wartet",
  "PlatformConnectionStatus_connected": "verbunden",
  "PlatformConnectionStatus_disconnected": "nicht verbunden",
} as const;

export const sharedAdminEn = {
  ...adminStructureEn,
  ...sharedProviderPricingEn,
  "Admin.Dashboard": "Dashboard",
  "Admin.Tenants": "Tenants",
  "Admin.Functions": "Tenant functions",
  "Admin.Interfaces": "Interfaces",
  "Admin.AiProviders": "AI providers",
  "Admin.ProviderCosts": "Provider costs",
  "Admin.AccessEmails": "Email",
  "Admin.ServiceNotifications": "Service notifications",
  "Admin.ServiceAlertEmailHint": "Address that receives a message whenever a failure source gets blocked. Leaving this empty still blocks — only without notification.",
  "Admin.ServiceAlertEmailSaveFailed": "Failed to save the recipient.",
  "Admin.Models": "Models",
  "Admin.Billing": "Plans",
  "Admin.BillingAndPaymentIntegration": "Plans & payments",
  "Admin.BillingAndPaymentIntegrationDescription": "Manage plans, credit pricing, and the platform payment integration.",
  "Admin.BillingAndInvoices": "Plans & invoices",
  "Admin.BillingAndInvoicesDescription": "Manage plans, payment integration, invoices, invoice sender details, and invoice design in separate sections.",
  "Admin.PaymentIntegration": "Payment integration",
  "Admin.Invoices": "Invoices",
  "Admin.PlatformLogs": "Logs",
  "Platform logs": "Platform logs",
  "Admin.PlatformManagementDescription": "Shared platform controls for tenants, tenant functions, plans, interfaces, and technical diagnostics.",
  "Admin.TenantsDescription": "Manage tenants, their accesses, and their assigned product data in one central place.",
  "Admin.NewTenants": "New tenants",
  "Admin.SelectedTenantOrDefaults": "Tenant or new tenants",
  "Admin.FunctionsDescription": "Functions per tenant and as the default for new tenants.",
  "Admin.InterfacesDescription": "Manage external platform and provider connections for the application.",
  "Admin.ProviderCostsDescription": "Review estimated and reconciled AI provider costs by period, function, provider, and model. Provider errors are in the platform logs.",
  "Admin.AccessEmailsDescription": "Sending account, templates, test delivery, and the recipient for service notifications.",
  "Admin.BillingDescription": "Manage platform plans, price versions, and plan-bound limits.",
  "Admin.PaymentIntegrationDescription": "Manage the central payment integration and platform Stripe status.",
  "Admin.InvoicesDescription": "System-wide invoices for accounting, tax reconciliation, and payment review.",
  "Admin.PlatformLogsDescription": "Technical platform events and API calls.",
  "Admin.ModelsDescription": "Manage centrally which models tenants and platform functions use.",
  "Admin.NewTenantFunctions": "Tenant functions for new tenants",
  "Admin.TenantFunctions": "Tenant functions per tenant",
  "Admin.TenantFunctionAccess": "Tenant functions",
  "Admin.RegistrationControls": "Registration controls",
  "Activate": "activate",
  "Deactivate": "deactivate",
  "Activate tenant": "Activate tenant",
  "Deactivate tenant": "Deactivate tenant",
  "ToggleTenantActiveConfirm": "The status of \"{name}\" will be changed.",
  "Tenant status saved": "Tenant status saved.",
  "Failed to toggle tenant active status": "Failed to update tenant status.",
  "AccessDenied": "Access denied.",
  "Severity": "Severity",
  "Component": "Component",
  "Event type": "Event type",
  "Message": "Message",
  "Context": "Context",
  "Technical details": "Technical details",
  "No technical details": "No technical details available.",
  "No platform logs": "No platform logs available.",
  "Delete all logs": "Delete all logs",
  "Platform logs deleted": "Platform logs deleted.",
  "Method": "Method",
  "Endpoint": "Endpoint",
  "Status Code": "Status code",
  "Request": "Request",
  "Response": "Response",
  "Project": "Project",
  "Campaign": "Campaign",
  "Delete platform logs": "Delete platform logs",
  "Delete platform logs description": "All stored platform logs will be permanently deleted.",
  "Failed to load platform logs": "Failed to load platform logs.",
  "Failed to delete platform logs": "Failed to delete platform logs.",
  "Functions saved successfully": "Functions saved successfully.",
  "Failed to load functions": "Failed to load functions.",
  "Failed to save functions": "Failed to save functions.",
  "Offered models saved successfully": "Available models saved successfully.",
  "Failed to save offered models": "Failed to save available models.",
  "Failed to load offered models": "Failed to load available models.",
  "Invoices": "Invoices",
  "PlatformInvoicesDescription": "System-wide invoices for accounting, tax reconciliation, and payment review.",
  "Invoice number": "Invoice number",
  "Invoice date": "Invoice date",
  "Service period": "Service period",
  "Gross amount": "Gross amount",
  "Status": "Status",
  "Receipt": "Receipt",
  "Download": "Download",
  "All tenants": "All tenants",
  "Deleted tenant": "Deleted tenant",
  "Deleted project": "Deleted project",
  "Failed to load invoices": "Failed to load invoices.",
  "Payment integration": "Payment integration",
  "Provider costs period": "Provider costs period",
  "Last 4 weeks": "last 4 weeks",
  "This month": "this month",
  "Last 12 months": "last 12 months",
  "Provider cost breakdown": "Provider cost breakdown",
  "Estimated provider cost": "Estimated provider cost",
  "Provider requests": "Provider requests",
  "Tokens": "Tokens",
  "By function": "by function",
  "By provider": "by provider",
  "By model": "by model",
  "Function": "Function",
  "Provider": "Provider",
  "Model": "Model",
  "Operation type": "Operation type",
  "Prompt tokens": "Prompt tokens",
  "Completion tokens": "Completion tokens",
  "Total tokens": "Total tokens",
  "Requests": "Requests",
  "Started": "Started",
  "Error message": "Error message",
  "completed": "completed",
  "failed": "failed",
  "No provider costs": "No provider costs available.",
  "Failed to load provider costs": "Provider costs could not be loaded.",
  "Provider costs source": "Cost basis",
  "Provider costs source description": "The breakdown uses captured AI provider calls. Costs come from stored provider prices. Provider errors and technical details are in the platform logs.",
  "ProviderPricingRefreshTriggered": "Provider prices were refreshed.",
  "ProviderPricingRefreshStatusPending": "pending",
  "ProviderPricingRefreshStatusRunning": "running",
  "ProviderPricingRefreshStatusSuccess": "retrieved",
  "ProviderPricingRefreshStatusWarning": "limited",
  "ProviderPricingRefreshStatusError": "failed",
  "ProviderPricingRefreshPendingDescription": "The daily price refresh has not completed since this service started.",
  "ProviderPricingRefreshRunningDescription": "The daily price refresh is running.",
  "ProviderPricingRefreshSuccessDescription": "Last successful refresh: {time}. Updated prices: {count}.",
  "ProviderPricingRefreshWarningDescription": "The last price refresh completed only partially. Existing verified prices remain visible as stale; unknown prices are not estimated.",
  "ProviderPricingRefreshForbiddenDescription": "A provider rejected the price refresh with 403 Forbidden. Existing verified prices remain visible as stale; unknown prices are not estimated.",
  "ProviderPricingRefreshDetailsPrefix": "Details",
  "ProviderPricingRefreshErrorDescription": "The last price refresh failed.",
  "Model provider saved": "Provider access saved and available to agents.",
  "Model provider added": "Provider added.",
  "Model provider removed": "Provider removed.",
  "Model provider activated": "Provider activated.",
  "Model provider deactivated": "Provider deactivated.",
  "Failed to save model provider secret": "Failed to save model provider access.",
  "Failed to save model providers": "Failed to save providers.",
  "Failed to remove model provider": "Failed to remove provider.",
  "Select provider first": "Please select a provider first.",
  "Api key required": "Please enter an API key.",
  "Base URL required": "Please enter the base URL.",
  "Show password": "show",
  "Hide password": "hide",
  "ProviderAccess.Provider": "Provider",
  "ProviderAccess.Status": "Status",
  "ProviderAccess.configured": "configured",
  "ProviderAccess.missing": "missing",
  "ProviderAccess.AccessData": "Access data",
  "ProviderAccess.OllamaBaseUrlPlaceholder": "http://localhost:11434",
  "ProviderAccess.ApiKeyPlaceholder": "Enter API key",
  "ProviderAccess.ApiKeyUpdatePlaceholder": "API key configured (type to overwrite)",
  "ProviderAccess.Actions": "Actions",
  "ProviderAccess.UpdateAccess": "update",
  "ProviderAccess.SaveAccess": "Save access",
  "ProviderAccess.TestAccess": "test",
  "ProviderAccess.Remove": "remove",
  "ProviderAccess.Model": "Model",
  "ProviderAccess.Operation": "Operation",
  "ProviderAccess.Tier": "Tier",
  "ProviderAccess.InputPerMillion": "Input per million",
  "ProviderAccess.CachedInputPerMillion": "Cached input per million",
  "ProviderAccess.OutputPerMillion": "Output per million",
  "ProviderAccess.Source": "Source",
  "ProviderAccess.FetchedAt": "Fetched at",
  "ProviderAccess.PanelTitle": "Provider access",
  "ProviderAccess.ProviderPricingRefreshTitle": "Provider prices",
  "ProviderAccess.ViewProviderPrices": "View provider prices",
  "ProviderAccess.ProviderPricingRefreshNow": "refresh now",
  "ProviderAccess.AddProviderAccess": "Add provider access",
  "ProviderAccess.SelectProvider": "Select provider",
  "ProviderAccess.AddProvider": "Add provider",
  "ProviderAccess.Deactivate": "Delete",
  "ProviderAccess.NoProvidersConfigured": "No providers configured",
  "ProviderAccess.ProviderPriceList": "Provider price list",
  "ProviderAccess.Close": "Close",
  "ProviderAccess.NoProviderPricesAvailable": "No provider prices available",
  // platformDashboardKpis (mQmarketing). "Selected period" is provided by sharedPeriodSelector.
  "System": "System",
  "Platform readiness": "Operational readiness",
  "Live connection": "Live connection",
  "Server events": "Server events",
  "Active agents": "Active agents",
  "Waiting agents": "Waiting agents",
  "Costs": "Costs",
  "Quality cases": "Quality cases",
  "needs attention": "needs attention",
  "PlatformConnectionStatus_waiting": "waiting",
  "PlatformConnectionStatus_connected": "connected",
  "PlatformConnectionStatus_disconnected": "not connected",
} as const;

export const sharedAdminRu = {
  ...adminStructureRu,
  ...sharedProviderPricingRu,
  "Admin.Dashboard": "Панель управления",
  "Admin.Tenants": "Клиенты",
  "Admin.Functions": "Функции клиентов",
  "Admin.Interfaces": "Интерфейсы",
  "Admin.AiProviders": "Поставщики ИИ",
  "Admin.ProviderCosts": "Расходы на провайдеров",
  "Admin.AccessEmails": "Эл. почта",
  "Admin.ServiceNotifications": "Уведомления о сбоях",
  "Admin.ServiceAlertEmailHint": "Адрес, на который приходит сообщение при блокировке источника ошибок. Если поле пустое, блокировка всё равно действует — только без уведомления.",
  "Admin.ServiceAlertEmailSaveFailed": "Не удалось сохранить получателя.",
  "Admin.Models": "Модели",
  "Admin.Billing": "Тарифы",
  "Admin.BillingAndPaymentIntegration": "Тарифы и платежи",
  "Admin.BillingAndPaymentIntegrationDescription": "Управляйте тарифами, ценами на кредиты и платёжной интеграцией платформы.",
  "Admin.BillingAndInvoices": "Тарифы и счета",
  "Admin.BillingAndInvoicesDescription": "Управляйте тарифами, платёжной интеграцией, счетами, данными выставителя и дизайном счетов в отдельных разделах.",
  "Admin.PaymentIntegration": "Платёжная интеграция",
  "Admin.Invoices": "Счета",
  "Admin.PlatformLogs": "Журналы",
  "Platform logs": "Журналы платформы",
  "Admin.PlatformManagementDescription": "Общее управление платформой: клиенты, доступ к функциям, тарифы, интерфейсы и техническая диагностика.",
  "Admin.TenantsDescription": "Управляйте клиентами, их доступами и связанными данными продуктов в одном центральном месте.",
  "Admin.NewTenants": "Новые клиенты",
  "Admin.SelectedTenantOrDefaults": "Клиент или новые клиенты",
  "Admin.FunctionsDescription": "Управляет доступом к функциям и особыми правами для отдельных клиентов или как значение по умолчанию для новых клиентов.",
  "Admin.InterfacesDescription": "Управляйте внешними подключениями платформ и провайдеров для приложения.",
  "Admin.ProviderCostsDescription": "Проверяйте расчётные и сверенные расходы на ИИ-провайдеров по периоду, функции, провайдеру и модели. Ошибки провайдеров находятся в журналах платформы.",
  "Admin.AccessEmailsDescription": "Учётная запись отправки, шаблоны, тестовая отправка и получатель уведомлений о сбоях.",
  "Admin.BillingDescription": "Управляйте тарифными планами, версиями цен и лимитами тарифов платформы.",
  "Admin.PaymentIntegrationDescription": "Управляйте центральной платёжной интеграцией и статусом Stripe платформы.",
  "Admin.InvoicesDescription": "Счета всей системы для бухгалтерии, налоговой сверки и проверки платежей.",
  "Admin.PlatformLogsDescription": "Технические события платформы и вызовы API.",
  "Admin.ModelsDescription": "Централизованно управляйте тем, какие модели используют клиенты и функции платформы.",
  "Admin.NewTenantFunctions": "Доступ к функциям для новых клиентов",
  "Admin.TenantFunctions": "Доступ к функциям по клиентам",
  "Admin.TenantFunctionAccess": "Функции клиентов",
  "Admin.RegistrationControls": "Управление регистрацией",
  "Activate": "активировать",
  "Deactivate": "деактивировать",
  "Activate tenant": "Активировать клиента",
  "Deactivate tenant": "Деактивировать клиента",
  "ToggleTenantActiveConfirm": "Статус \"{name}\" будет изменён.",
  "Tenant status saved": "Статус клиента сохранён.",
  "Failed to toggle tenant active status": "Не удалось изменить статус клиента.",
  "AccessDenied": "Доступ запрещён.",
  "Severity": "Уровень важности",
  "Component": "Компонент",
  "Event type": "Тип события",
  "Message": "Сообщение",
  "Context": "Контекст",
  "Technical details": "Технические детали",
  "No technical details": "Технические детали отсутствуют.",
  "No platform logs": "Журналы платформы отсутствуют.",
  "Delete all logs": "удалить все журналы",
  "Platform logs deleted": "Журналы платформы удалены.",
  "Method": "Метод",
  "Endpoint": "Конечная точка",
  "Status Code": "Код статуса",
  "Request": "Запрос",
  "Response": "Ответ",
  "Project": "Проект",
  "Campaign": "Кампания",
  "Delete platform logs": "Удалить журналы платформы",
  "Delete platform logs description": "Все сохранённые журналы платформы будут удалены безвозвратно.",
  "Failed to load platform logs": "Не удалось загрузить журналы платформы.",
  "Failed to delete platform logs": "Не удалось удалить журналы платформы.",
  "Functions saved successfully": "Функции успешно сохранены.",
  "Failed to load functions": "Не удалось загрузить функции.",
  "Failed to save functions": "Не удалось сохранить функции.",
  "Offered models saved successfully": "Доступные модели успешно сохранены.",
  "Failed to save offered models": "Не удалось сохранить доступные модели.",
  "Failed to load offered models": "Не удалось загрузить доступные модели.",
  "Invoices": "Счета",
  "PlatformInvoicesDescription": "Счета всей системы для бухгалтерии, налоговой сверки и проверки платежей.",
  "Invoice number": "Номер счета",
  "Invoice date": "Дата счета",
  "Service period": "Период оказания услуг",
  "Gross amount": "Сумма брутто",
  "Status": "Статус",
  "Receipt": "Документ",
  "Download": "скачать",
  "All tenants": "все клиенты",
  "Deleted tenant": "Удаленный клиент",
  "Deleted project": "Удаленный проект",
  "Failed to load invoices": "Не удалось загрузить счета.",
  "Payment integration": "Платёжная интеграция",
  "Provider costs period": "Период расходов на провайдеров",
  "Last 4 weeks": "последние 4 недели",
  "This month": "этот месяц",
  "Last 12 months": "последние 12 месяцев",
  "Provider cost breakdown": "Детализация расходов на провайдеров",
  "Estimated provider cost": "расчётные расходы на провайдеров",
  "Provider requests": "Запросы к провайдерам",
  "Tokens": "Токены",
  "By function": "по функциям",
  "By provider": "по провайдерам",
  "By model": "по моделям",
  "Function": "Функция",
  "Provider": "Провайдер",
  "Model": "Модель",
  "Operation type": "Тип операции",
  "Prompt tokens": "Токены запроса",
  "Completion tokens": "Токены ответа",
  "Total tokens": "Токены всего",
  "Requests": "Запросы",
  "Started": "начато",
  "Error message": "Сообщение об ошибке",
  "completed": "завершено",
  "failed": "не удалось",
  "No provider costs": "Расходы на провайдеров отсутствуют.",
  "Failed to load provider costs": "Не удалось загрузить расходы на провайдеров.",
  "Provider costs source": "Основа расчёта расходов",
  "Provider costs source description": "Детализация использует зарегистрированные вызовы ИИ-провайдеров. Расходы берутся из сохранённых цен провайдеров. Ошибки провайдеров и технические детали находятся в журналах платформы.",
  "ProviderPricingRefreshTriggered": "Цены провайдеров обновлены.",
  "ProviderPricingRefreshStatusPending": "ожидается",
  "ProviderPricingRefreshStatusRunning": "выполняется",
  "ProviderPricingRefreshStatusSuccess": "получено",
  "ProviderPricingRefreshStatusWarning": "частично",
  "ProviderPricingRefreshStatusError": "ошибка",
  "ProviderPricingRefreshPendingDescription": "Ежедневное обновление цен ещё не завершалось с момента запуска этой службы.",
  "ProviderPricingRefreshRunningDescription": "Ежедневное обновление цен выполняется в данный момент.",
  "ProviderPricingRefreshSuccessDescription": "Последнее успешное обновление: {time}. Обновлённые цены: {count}.",
  "ProviderPricingRefreshWarningDescription": "Последнее обновление цен завершилось лишь частично. Проверенные цены остаются видимыми как устаревшие; неизвестные цены не оцениваются.",
  "ProviderPricingRefreshForbiddenDescription": "Провайдер отклонил запрос цен с ошибкой 403 Forbidden. Проверенные цены остаются видимыми как устаревшие; неизвестные цены не оцениваются.",
  "ProviderPricingRefreshDetailsPrefix": "Детали",
  "ProviderPricingRefreshErrorDescription": "Последнее обновление цен завершилось ошибкой.",
  "Model provider saved": "Доступ к провайдеру сохранён и доступен агентам.",
  "Model provider added": "Провайдер добавлен.",
  "Model provider removed": "Провайдер удалён.",
  "Model provider activated": "Провайдер активирован.",
  "Model provider deactivated": "Провайдер деактивирован.",
  "Failed to save model provider secret": "Не удалось сохранить доступ к провайдеру.",
  "Failed to save model providers": "Не удалось сохранить провайдеров.",
  "Failed to remove model provider": "Не удалось удалить провайдера.",
  "Select provider first": "Пожалуйста, сначала выберите провайдера.",
  "Api key required": "Пожалуйста, введите API-ключ.",
  "Base URL required": "Пожалуйста, введите базовый URL.",
  "Show password": "показать",
  "Hide password": "скрыть",
  "ProviderAccess.Provider": "Провайдер",
  "ProviderAccess.Status": "Статус",
  "ProviderAccess.configured": "настроено",
  "ProviderAccess.missing": "отсутствует",
  "ProviderAccess.AccessData": "Данные доступа",
  "ProviderAccess.OllamaBaseUrlPlaceholder": "http://localhost:11434",
  "ProviderAccess.ApiKeyPlaceholder": "введите API-ключ",
  "ProviderAccess.ApiKeyUpdatePlaceholder": "API-ключ сохранён (введите новый для изменения)",
  "ProviderAccess.Actions": "Действия",
  "ProviderAccess.UpdateAccess": "обновить",
  "ProviderAccess.SaveAccess": "сохранить доступ",
  "ProviderAccess.TestAccess": "проверить",
  "ProviderAccess.Remove": "удалить",
  "ProviderAccess.Model": "Модель",
  "ProviderAccess.Operation": "Операция",
  "ProviderAccess.Tier": "Уровень",
  "ProviderAccess.InputPerMillion": "Ввод за миллион",
  "ProviderAccess.CachedInputPerMillion": "кешированный ввод за миллион",
  "ProviderAccess.OutputPerMillion": "Вывод за миллион",
  "ProviderAccess.Source": "Источник",
  "ProviderAccess.FetchedAt": "Получено",
  "ProviderAccess.PanelTitle": "Доступы к провайдерам",
  "ProviderAccess.ProviderPricingRefreshTitle": "Цены провайдеров",
  "ProviderAccess.ViewProviderPrices": "показать цены провайдеров",
  "ProviderAccess.ProviderPricingRefreshNow": "обновить сейчас",
  "ProviderAccess.AddProviderAccess": "добавить доступ к провайдеру",
  "ProviderAccess.SelectProvider": "выбрать провайдера",
  "ProviderAccess.AddProvider": "добавить провайдера",
  "ProviderAccess.Deactivate": "удалить",
  "ProviderAccess.NoProvidersConfigured": "Провайдеры не настроены",
  "ProviderAccess.ProviderPriceList": "Прайс-лист провайдеров",
  "ProviderAccess.Close": "Закрыть",
  "ProviderAccess.NoProviderPricesAvailable": "Цены провайдеров недоступны",
} as const;
